var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { mixinStyles } from "@bookingcom/bui-core/utilities/styles";
import AspectRatio from "../AspectRatio/index.js";
import styles from "@bookingcom/bui-core/css/SkeletonLoader.module.css";
var SkeletonLoader = function (props) {
    var variant = props.variant, width = props.width, _a = props.color, color = _a === void 0 ? "neutral" : _a, _b = props.aspectRatio, aspectRatio = _b === void 0 ? "1:1" : _b, className = props.className, tagName = props.tagName, attributes = props.attributes, mixin = props.mixin;
    var rootClassNames = classNames(styles.root, color === "inherit"
        ? styles["root--color-inherit"]
        : styles["root--color-neutral"], className, mixinClassNames(mixin));
    var TagName = tagName || "div";
    var lineAttributes = __assign(__assign({}, attributes), { style: __assign(__assign({}, mixinStyles(mixin)), { width: width }) });
    if (variant === "title") {
        return (React.createElement(TagName, __assign({}, lineAttributes, { className: rootClassNames }),
            React.createElement("span", { className: classNames(styles.skeleton, styles.title) })));
    }
    if (variant === "box") {
        return (React.createElement(AspectRatio, { width: width, ratio: aspectRatio, attributes: attributes, className: rootClassNames },
            React.createElement("span", { className: classNames(styles.skeleton, styles.box) })));
    }
    return (React.createElement(TagName, __assign({}, lineAttributes, { className: rootClassNames }),
        React.createElement("span", { className: classNames(styles.skeleton, styles.line) }),
        variant === "three-lines" && (React.createElement("span", { className: classNames(styles.skeleton, styles.line) })),
        (variant === "two-lines" || variant === "three-lines") && (React.createElement("span", { className: classNames(styles.skeleton, styles.halfLine) }))));
};
export default SkeletonLoader;
